import axios from 'axios'
import { Field, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Modal, Row } from 'react-bootstrap'
import { FaCheckCircle, FaEye, FaEyeSlash } from 'react-icons/fa'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import Swal from 'sweetalert2'
import * as yup from 'yup'
import api from '../../apiClient'
import ActivataionAccount from './ActivataionAccount'
import TextField from './sessions/TextField'
import './StyleSession/signup.css'
const HRSignup = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1); // Add state for current step
  const initialFormValues = {
    userName: "",
    userEmail: "",
    phoneNumber: "", // Add phone number field
     appliedDate: new Date().toISOString(),
    password: "",
    confirmPassword: "",
    agreeToTermsAndCondition: false,
    companyName: "",
    companyWebsite: "",
    userRole: "HR",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [passwordCriteriaError, setPasswordCriteriaError] = useState(false);
  const [passwordMatchError, setPasswordMatchError] = useState(false);
  // const [protocol, setProtocol] = useState('http');
  const [tld, setTld] = useState(".com");
  const [domain, setDomain] = useState("");
  const [emailExistsError, setEmailExistsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [disableFormFields, setDisableFormFields] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [enterOtpValue, setEnterOtpValue] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [agreeToTermsAndConditionByCheck, setAgreeToTermsAndConditionByCheck] =
    useState(false);
  const [showActivationModal, setShowActivationModal] = useState(false); // State to control modal visibility
  const [userEmail, setUserEmail] = useState(""); // State to hold user email
  const [userExistsMesg, setUserExistsMsg] = useState("");
  const [userDeactivtaeErrorMsg, setUserDeactivateErrorMsg] = useState("");
  const [jobboxId, setJobboxid] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Add state for password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Add state for re-password visibility
  const [setupMessage, setSetupMessage] = useState(""); // Change initial value to empty string instead of false
  const [fieldError, setFieldError] = useState(""); // Fix: Properly initialize fieldError state
  const publicDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "protonmail.com",
    "icloud.com",
    "zoho.com",
    "mail.com",
    "gmx.com",
    "yandex.com",
    "inbox.com",
    "fastmail.com",

    // Popular global and country-specific domains
    "hotmail.co.uk",
    "hotmail.fr",
    "msn.com",
    "yahoo.fr",
    "wanadoo.fr",
    "orange.fr",
    "comcast.net",
    "yahoo.co.uk",
    "yahoo.com.br",
    "yahoo.co.in",
    "live.com",
    "rediffmail.com",
    "free.fr",
    "gmx.de",
    "web.de",
    "yandex.ru",
    "ymail.com",
    "libero.it",
    "uol.com.br",
    "bol.com.br",
    "mail.ru",
    "cox.net",
    "hotmail.it",
    "sbcglobal.net",
    "sfr.fr",
    "live.fr",
    "verizon.net",
    "live.co.uk",
    "googlemail.com",
    "yahoo.es",
    "ig.com.br",
    "live.nl",
    "bigpond.com",
    "terra.com.br",
    "yahoo.it",
    "neuf.fr",
    "yahoo.de",
    "alice.it",
    "rocketmail.com",
    "att.net",
    "laposte.net",
    "facebook.com",
    "bellsouth.net",
    "yahoo.in",
    "hotmail.es",
    "charter.net",
    "yahoo.ca",
    "yahoo.com.au",
    "rambler.ru",
    "hotmail.de",
    "tiscali.it",
    "shaw.ca",
    "yahoo.co.jp",
    "sky.com",
    "earthlink.net",
    "optonline.net",
    "freenet.de",
    "t-online.de",
    "aliceadsl.fr",
    "virgilio.it",
    "home.nl",
    "qq.com",
    "telenet.be",
    "me.com",
    "yahoo.com.ar",
    "tiscali.co.uk",
    "yahoo.com.mx",
    "voila.fr",
    "gmx.net",
    "planet.nl",
    "tin.it",
    "live.it",
    "ntlworld.com",
    "arcor.de",
    "yahoo.co.id",
    "frontiernet.net",
    "hetnet.nl",
    "live.com.au",
    "yahoo.com.sg",
    "zonnet.nl",
    "club-internet.fr",
    "juno.com",
    "optusnet.com.au",
    "blueyonder.co.uk",
    "bluewin.ch",
    "skynet.be",
    "sympatico.ca",
    "windstream.net",
    "mac.com",
    "centurytel.net",
    "chello.nl",
    "live.ca",
    "aim.com",
    "bigpond.net.au",
    "hushmail.com",
    "mailfence.com",
    "tutanota.com",
    "posteo.net",
    "runbox.com",
    "disroot.org",
    "openmailbox.org",
    "startmail.com",
    "eclipso.de",
    "mailbox.org",
    "pm.me",
    "keemail.me",
    "shortmail.com",
    "inbox.lv",
    "my.com",
    "naver.com",
    "daum.net",
    "hanmail.net",
    "seznam.cz",
    "centrum.cz",
    "volny.cz",
    "onet.pl",
    "wp.pl",
    "interia.pl",
    "o2.pl",
    "yeah.net",
    "12.com",
    "163.com",
    "sina.com",
    "vip.163.com",
    "netease.com",
    "email.cz",
    "email.it",
    "protonmail.ch",
    "emailaccount.com",
    "usa.com",
    "asia.com",
    "europe.com",
    "africamail.com",
    "swissmail.org",
    "dr.com",
    "mail.kz",
    "protonmail.de",
    "protonmail.net",
  ];

  // Add useEffect to track setupMessage changes
  useEffect(() => {}, [setupMessage]);

  // // Update jobboxid whenever any of the fields change
  // const updateJobboxid = () => {
  //   if (domain) {
  //     setJobboxid(`${domain}${tld}@jobbox.one`);
  //   }
  // };
  // Update jobboxid whenever any of the fields change
  // Update jobboxid whenever domain or tld changes
  useEffect(() => {
    if (domain) {
      const lowerDomain = domain.toLowerCase();
      if (lowerDomain.endsWith(".com")) {
        const nameOnly = lowerDomain.slice(0, -4); // Removes last 4 chars (".com")
        setJobboxid(`${nameOnly}@jobbox.one`);
      } else {
        setJobboxid(`${lowerDomain}@jobbox.one`);
      }
    }
  }, [domain, tld]);

  // Handle domain change
  const handleDomainChange = (event) => {
    setDomain(event.target.value);
    // updateJobboxid(); // Update jobboxid after domain change
  };

  // Handle tld change
  const handleTldChange = (event) => {
    setTld(event.target.value);
    // updateJobboxid(); // Update jobboxid after tld change
  };
  
  useEffect(() => {
    localStorage.setItem("HrRegistrationForm", JSON.stringify(formValues));
  }, [formValues]);

  useEffect(() => {
    const storedFormValues =
      JSON.parse(localStorage.getItem("HrRegistrationForm")) ||
      initialFormValues;
    if (
      Object.keys(formValues).length === 0 &&
      formValues.constructor === Object
    ) {
      setFormValues(storedFormValues);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("HrRegistrationForm", JSON.stringify(formValues));
  }, [formValues]);

  useEffect(() => {
    // Clear localStorage when the component unmounts
    return () => {
      localStorage.removeItem("HrRegistrationForm");
    };
  }, []);

  const location = useLocation();
  const companyNameFromLocation = location.state?.companyName;
  const companyWebsiteFromLocation = location.state?.companyWebsite;

  // Use useState to manage companyName and companyWebsite state
  const [companyName, setCompanyName] = useState(companyNameFromLocation || ""); // Default to empty string if not present
  const [companyWebsite, setCompanyWebsite] = useState(
    companyWebsiteFromLocation || ""
  ); // Default to empty string if not present

  const handleEmailChange = (e, handleChange) => {
    const email = e.target.value;
    const domain = email.split("@")[1];

    if (domain && publicDomains.includes(domain.toLowerCase())) {
      setFieldError(
        "Please use your official company email address. Free email providers like Gmail, Yahoo, etc. are not allowed for HR registration."
      );
      // setDisableFormFields(true);
    } else {
      setFieldError(""); // clear error
      setDisableFormFields(false);
    }
    handleChange(e);
    extractCompanyNameFromEmail(e.target.value);
  };

  const extractCompanyNameFromEmail = async (email) => {
    if (!email) return null;
    const [_, domainPart] = email.split("@");
    if (!domainPart) return null;

    let companyName = domainPart.toLowerCase();
    if (companyName.endsWith(".com")) {
      companyName = companyName.replace(".com", "");
    }

    const jobboxId = `${companyName}@jobbox.one`;
    setJobboxid(jobboxId);
    setCompanyName(companyName);

    try {
      const response = await axios.get(`${BASE_API_URL}/checkJobboxemail`, {
        params: { jobboxEmail: jobboxId },
      });

      if (response.data) {
        const { companyName, websiteLink, jobboxEmail } = response.data;
        const sanitizedDomain = websiteLink.replace(/^https?:\/\/(www\.)?/, "");
        setCompanyName(companyName);
        setDomain(sanitizedDomain);
        setJobboxid(jobboxEmail);
        setSetupMessage(
          "🎉 Congratulations! Seems your company Jobbox is already set up."
        );
        return response.data; // Return the company data
      } else {
        // Clear all fields and messages for new company
        setCompanyName("");
        setDomain("");
        setJobboxid("");
        setSetupMessage("");
        return null; // Return null to indicate no existing company
      }
    } catch (error) {
      setSetupMessage("");
      return null; // Return null on error
    }
  };

  // Validation schema using Yup
  const validationSchema = yup.object().shape({
    userName: yup.string().required("Name is required"),
    userEmail: yup
      .string()
      .email("Invalid email")
      .required("Email is required"),
    phoneNumber: yup.string().required("Phone number is required"),
    password: yup
      .string()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,20}$/,
        "Invalid password match..."
      ),
    confirmPassword: yup
      .string()
      .required("Repeat Password is required")
      .oneOf([yup.ref("password")], "Passwords must match"),
    agreeToTermsAndCondition: yup
      .bool()
      .oneOf([true], "You must agree to validate your email"),
  });

  // Function to validate password criteria
  const validatePassword = (values) => {
    const { password, confirmPassword } = values;
    const isValidPassword =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,20}$/.test(
        password
      );
    const passwordsMatch = password === confirmPassword;

    if (!isValidPassword) {
      setPasswordCriteriaError(true);
      return false;
    }

    if (!passwordsMatch) {
      setPasswordMatchError(true);
      return false;
    }

    return true;
  };
  // // Function to check if the company is already registered
  // const checkCompanyRegistration = async (companyName) => {
  //     try {
  //         const response = await api.checkCompany(companyName); // API call to check company
  //         return response.data; // Assuming the response contains the company details
  //     } catch (error) {
  //         return null; // Return null in case of error
  //     }
  // };
  // Function to handle form submission
  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    // Password validation
    if (!validatePassword(values)) {
      setSubmitting(false);
      return;
    }

    values.companyName = companyName;
    values.companyWebsite = companyWebsite;

    // Set company website if domain is provided
    if (domain) {
      values.companyWebsite = `https://www.${domain}`;
      values.jobboxId = jobboxId;
    }

    const userData = {
      ...values,
      userRole: "HR",
    };

    try {
      const response = await api.saveUser(userData);

      if (
        !response.data ||
        response.data === "undefined" ||
        response.data === ""
      ) {
        setEmailExistsError(true);
        setSubmitting(false);
        return;
      }
      // GA4 tracking event for HR signup
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "hr_signup",
        user_email: userData.userEmail || "unknown",
        company_name: userData.companyName || "unknown",
        method: "email",
      });
      // Success notification
      Swal.fire({
        icon: "success",
        title: "Registration Successful!",
        text: "You have successfully Registered. Jobbox admin will verify your details and grant the system access. It may take 24-48 hours.",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          const redirectUrl =
            window.location.hostname === "localhost"
              ? "http://localhost:3001"
              : "https://jobbox.one";
          window.location.href = redirectUrl;
        }
      });
    } catch (error) {
      setErrorMessage("Error registering User. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  // Function to handle OTP verification
  const handleOTPVerification = () => {
    if (otpValue == enterOtpValue) {
      setOtpVerified(true);
      setShowOTPModal(false);
      // Proceed to submit form data after OTP verification
      setSuccessMessage("Email verified successfully!");
    } else {
      setOtpVerified(false);
      setDisableFormFields(false);
      setErrorMessage("Invalid varification code. Please try again.");
    }
  };

  // Function to send OTP
  const sendOTP = async (email) => {
    if (!email || email === "undefined" || email === "") {
      // alert("Please enter an email first.");
      toast.error("Please enter an email first."); // Display error message --->   npm install react-toastify

      setDisableFormFields(false);
      return; // Exit the function early
    } else {
      const checkUserResponse = await api.checkUser(email);

      if (checkUserResponse.status === 200) {
        if (checkUserResponse.data.deActivate === true) {
          setUserEmail(email);
          setUserDeactivateErrorMsg(
            <span>
              Your email already exists. Please{" "}
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault(); // Prevent default link behavior
                  localStorage.setItem("redirectAfterLogin", "hr-signup");
                  setShowActivationModal(true); // Show the activation modal
                }}
              >
                Activate Your Account
              </Link>{" "}
              to log in to your account.
            </span>
          );
        } else {
          setUserExistsMsg(
            <span>
              Your email already exists. Please{" "}
              <Link to="/signin" state={{ userRole: "Candidate" }}>
                click here
              </Link>{" "}
              to log in to your account.
            </span>
          );
        }
      } else {
        let loadingPopup;

        try {
          // Show loading message using SweetAlert
          loadingPopup = Swal.fire({
            title: "Verifing your email...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          const response = await api.validateUserEmail(email);
          setOtpValue(response.data);
          setShowOTPModal(true);
          if (response.data) {
            Swal.close();
            toast.success("Varification code sent successfully!");
          }
        } catch (error) {
          if (loadingPopup) {
            Swal.close();
          }
          setErrorMessage(
            "Error sending varification code. Please try again later."
          );
        }
      }
    }
  };
  // Function to update user data (in case of email already exists)
  const updateUserData = async (values) => {
    try {
      const response = await api.updateUserData(values); // PUT request to update user data

      if (response.data) {
        Swal.fire({
          icon: "success",
          title: "Update Successful!",
          text: "Your data has been updated successful.",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/signin");
          }
        });
      } else {
        setErrorMessage(true);
        return;
      }
    } catch (error) {
      alert("Data not updated");
    }
  };

  // Function to show the password criteria error
  const showErrorToast = () => {
    toast.error(
      <div
        className="alert alert-info"
        style={{ maxWidth: "400px", margin: "20px auto", borderRadius: "5px" }}
      >
        <h5>Password Guidelines</h5>
        <ul className="list-unstyled">
          <li>• At least one number</li>
          <li>• One special character</li>
          <li>• One uppercase letter</li>
          <li>• One lowercase letter</li>
          <li>• Between 8 to 20 characters</li>
        </ul>
      </div>
    );
  };

  // Effect to show the toast when the error is true
  React.useEffect(() => {
    if (passwordCriteriaError) {
      showErrorToast();
    }
  }, [passwordCriteriaError]);

  const homeUrl =
    window.location.hostname === "localhost"
      ? "http://localhost:3001"
      : "https://jobbox.one";

  // Add function to handle next step
  const handleNextStep = async (values) => {
    if (currentStep === 1 && otpVerified) {
      const email = values.userEmail;
      const registeredCompany = await extractCompanyNameFromEmail(email);

      if (registeredCompany) {
        // Auto-fill fields with registered company details
        setCompanyName(registeredCompany.companyName);
        setCompanyWebsite(registeredCompany.websiteLink);
        setJobboxid(registeredCompany.jobboxEmail);
        setSetupMessage(
          "🎉 Congratulations! Your company is already registered in Jobbox. You can register now."
        );
      }
      // No else block - let user enter details manually without any toast message

      setCurrentStep(2);
    }
  };

  // Add function to handle previous step
  const handlePreviousStep = () => {
    if (currentStep === 2) {
      setCurrentStep(1);
    }
  };

  return (
   <div>
  <div
    className="auth-layout-wrap"
    style={{
      backgroundImage:
        'linear-gradient(rgba(5,15,35,0.72), rgba(0,10,30,0.78)), url("/hr.jpg")',
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
    }}
  >
    <div className="auth-content d-flex align-items-center justify-content-center min-vh-100">
      <Card className="o-hidden card bg-transparent border-0 shadow-none">
        <Row>
          <Col xs={12} md={6} className="text-center auth-cover">
            <div className="ps-3 auth-right">
              <div className="auth-logo text-center mt-4">
                <a href={homeUrl}>
                  <img
                    src="/jb_logo.png"
                    alt="jobbox_logo"
                    style={{ maxWidth: "180px" }}
                  />
                </a>
              </div>

              <div className="w-100 h-100 justify-content-center d-flex flex-column">
                <p
                  style={{
                    color: "#ffffff",
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                >
                  Already registered?{" "}
                  <Button
                    onClick={() => navigate("/hr-sign-in")}
                    style={{ textAlign: "center" }}
                  >
                    Login
                  </Button>
                </p>

                <p style={{ color: "#cfe9ff" }}>
                  New Employer/HR? Register below to join Jobbox.
                </p>
              </div>

              <h3 style={{ color: "#ffffff" }}>
                Benefits of joining Jobbox
              </h3>

              <div className="info-list">
                <h6
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "20px",
                    color: "#ffffff",
                  }}
                >
                  <FaCheckCircle
                    style={{
                      marginRight: "8px",
                      color: "#00ff88",
                    }}
                  />
                  Create/Claim your own unique and secured Jobbox.
                </h6>

                <h6
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "20px",
                    color: "#ffffff",
                  }}
                >
                  <FaCheckCircle
                    style={{
                      marginRight: "8px",
                      color: "#00ff88",
                    }}
                  />
                  Find your next leaders with senior Ninja Applicants.
                </h6>

                <h6
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "20px",
                    color: "#ffffff",
                  }}
                >
                  <FaCheckCircle
                    style={{
                      marginRight: "8px",
                      color: "#00ff88",
                    }}
                  />
                  Access to Top Talent.
                </h6>

                <h6
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "20px",
                    color: "#ffffff",
                  }}
                >
                  <FaCheckCircle
                    style={{
                      marginRight: "8px",
                      color: "#00ff88",
                    }}
                  />
                  Access Applicants for whom your company is a dream destination.
                </h6>

                <h6
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "20px",
                    color: "#ffffff",
                  }}
                >
                  <FaCheckCircle
                    style={{
                      marginRight: "8px",
                      color: "#00ff88",
                    }}
                  />
                  Tracking & Analytics.
                </h6>
              </div>
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div className="p-4">
              <h1
                className="mb-3 text-18 fw-bold text-center"
                style={{
                  color: "#ffffff",
                  fontSize: "28px",
                  textShadow:
                    "0 0 10px rgba(0,180,255,0.6)",
                }}
              >
                Employee/HR Registration Form
              </h1>

              {/* KEEP YOUR FULL FORMIK FORM HERE EXACTLY SAME */}
              {/* ONLY APPLY WHITE LABEL STYLE TO TEXTFIELDS */}

              <Formik
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  isSubmitting,
                }) => (
                   <Form className="form">
                        {currentStep === 1 ? (
                          <>
                            {/* Step 1 Fields */}
                            <TextField
                              type="text"
                              name="userName"
                              label={
                                <>
                                  <span>Your name</span>
                                  <span style={{ color: "red" }}>*</span>
                                </>
                              }
                              required
                              placeholder="Enter your name"
                              value={values.userName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              helperText={errors.userName}
                              error={errors.userName && touched.userName}
                              disabled={disableFormFields}
                              fullWidth
                              variant="outlined"
                              margin="normal"
                            />

                            <TextField
                              type="tel"
                              name="phoneNumber"
                              label={
                                <>
                                  <span>Phone Number</span>
                                  <span style={{ color: "red" }}>*</span>
                                </>
                              }
                              required
                              placeholder="Enter your phone number"
                              value={values.phoneNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              helperText={errors.phoneNumber}
                              error={errors.phoneNumber && touched.phoneNumber}
                              disabled={disableFormFields}
                              fullWidth
                              variant="outlined"
                              margin="normal"
                            />

                            {/* <div>
                                                            {/* <label style={{ marginRight: '10px' }}>
                                                                Your Official Company Email <span style={{ color: 'red' }}>*</span>
                                                            </label> 
                                                            <section style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}> */}
                            <TextField
                              type="email"
                              name="userEmail"
                              required
                              placeholder="Enter your email"
                              label={
                                <>
                                  <span> Your Official Company Email</span>
                                  <span style={{ color: "red" }}>*</span>
                                </>
                              }
                              value={values.userEmail}
                              onChange={(e) =>
                                handleEmailChange(e, handleChange)
                              }
                              onBlur={handleBlur}
                              helperText={errors.userEmail}
                              error={
                                touched.userEmail && Boolean(errors.userEmail)
                              }
                              disabled={disableFormFields || emailExistsError}
                              fullWidth
                              variant="outlined"
                              margin="normal"
                              style={{ flex: 1, marginRight: "10px" }}
                            />

                            {/* {!otpVerified && (
                                                                    <Button
                                                                        disabled={disableFormFields || otpVerified}
                                                                        className="mb-2"
                                                                        onClick={() => {
                                                                            setDisableFormFields(true);
                                                                            sendOTP(values.userEmail);
                                                                        }}
                                                                        style={{ marginLeft: '10px' }}
                                                                    >
                                                                        Validate my email
                                                                    </Button>
                                                                )}
                                                            </section>
                                                            {successMessage && <p className="success-message">{successMessage}</p>}
                                                        </div> */}

                            <div className="position-relative">
                              <TextField
                                type={showPassword ? "text" : "password"}
                                name="password"
                                label={
                                  <>
                                    <span>Password</span>
                                    <span style={{ color: "red" }}>*</span>
                                  </>
                                }
                                required
                                placeholder="Enter your password"
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                helperText={errors.password}
                                error={errors.password && touched.password}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                style={{ marginBottom: "15px" }}
                              />
                              <button
                                type="button"
                                className="btn btn-link position-absolute"
                                style={{
                                  right: "60px",
                                  top:
                                    errors.password && touched.password
                                      ? "50%"
                                      : "70%",
                                  transform: "translateY(-50%)",
                                  padding: "0",
                                  color: "#6c757d",
                                  zIndex: "1",
                                  background: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                {showPassword ? (
                                  <FaEyeSlash size={18} />
                                ) : (
                                  <FaEye size={18} />
                                )}
                              </button>
                            </div>

                            <div className="position-relative">
                              <TextField
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                label={
                                  <>
                                    <span>Confirm Password</span>
                                    <span style={{ color: "red" }}>*</span>
                                  </>
                                }
                                required
                                placeholder="Re-enter your password"
                                value={values.confirmPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                helperText={errors.confirmPassword}
                                error={
                                  errors.confirmPassword &&
                                  touched.confirmPassword
                                }
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                style={{ marginBottom: "15px" }}
                              />
                              <button
                                type="button"
                                className="btn btn-link position-absolute"
                                style={{
                                  right: "60px",
                                  top:
                                    errors.password && touched.password
                                      ? "50%"
                                      : "70%",
                                  transform: "translateY(-50%)",
                                  padding: "0",
                                  color: "#6c757d",
                                  zIndex: "1",
                                  background: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setShowConfirmPassword(!showConfirmPassword)
                                }
                              >
                                {showConfirmPassword ? (
                                  <FaEyeSlash size={18} />
                                ) : (
                                  <FaEye size={18} />
                                )}
                              </button>
                            </div>
                            <div className="d-flex justify-content-center">
                              <section
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: "10px",
                                }}
                              >
                                {!otpVerified && (
                                  <Button
                                    disabled={disableFormFields || otpVerified}
                                    className="mb-2"
                                    onClick={() => {
                                      setDisableFormFields(true);
                                      sendOTP(values.userEmail);
                                    }}
                                    style={{ marginLeft: "10px" }}
                                  >
                                    Validate my email
                                  </Button>
                                )}
                              </section>
                              {successMessage && (
                                <p className="success-message">
                                  {successMessage}
                                </p>
                              )}
                            </div>
                            <div>
                              {fieldError && (
                                <p style={{ color: "red" }}>{fieldError}</p>
                              )}
                            </div>
                            <div className="d-flex justify-content-end mt-3">
                              <Button
                                onClick={handleNextStep}
                                disabled={!otpVerified}
                                className="btn btn-primary"
                              >
                                Next
                              </Button>
                            </div>
                          </>
                        ) : (
                          <>
                            {/* Step 2 Fields */}
                            {!companyNameFromLocation && (
                              <>
                                <TextField
                                  type="text"
                                  name="companyName"
                                  label={
                                    <>
                                      <span>Company name</span>
                                      <span style={{ color: "red" }}>*</span>
                                    </>
                                  }
                                  required
                                  placeholder="Enter your company name"
                                  value={companyName || values.companyName}
                                  onChange={(e) =>
                                    setCompanyName(e.target.value.trim())
                                  }
                                  onBlur={handleBlur}
                                  helperText={errors.companyName}
                                  error={
                                    errors.companyName && touched.companyName
                                  }
                                  fullWidth
                                  variant="outlined"
                                  margin="normal"
                                  style={{ marginBottom: "15px" }}
                                />

                                <div style={{ marginBottom: "15px" }}>
                                  <label>
                                    Company Website{" "}
                                    <span
                                      className="required"
                                      style={{ color: "red" }}
                                    >
                                      *
                                    </span>
                                  </label>
                                  <p style={{ color: "#555" }}>
                                    <strong>Note:</strong> Please do not include{" "}
                                    <code>https://www.</code> in the URL. Just
                                    enter the remaining part of the website
                                    (e.g., <code>companyname.com</code>).
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span style={{ marginRight: "10px" }}>
                                      www.
                                    </span>
                                    <TextField
                                      type="text"
                                      name="companyWebsite"
                                      placeholder="domain"
                                      style={{ width: "400px" }}
                                      onChange={handleDomainChange}
                                      value={domain}
                                      fullWidth
                                    />
                                  </div>
                                </div>

                                <TextField
                                  type="text"
                                  name="jobboxid"
                                  label={
                                    <>
                                      Your JOBBOX id:{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </>
                                  }
                                  required
                                  placeholder="Your Jobbox id"
                                  value={jobboxId}
                                  onChange={(e) => setJobboxid(e.target.value)}
                                  fullWidth
                                  variant="outlined"
                                  margin="normal"
                                  style={{ marginBottom: "15px" }}
                                />

                                <p style={{ fontSize: "12px", color: "#555" }}>
                                  (This will be a unique identifier for your
                                  company and applicants can apply sending
                                  resume to this ID too)
                                </p>
                              </>
                            )}

                            {setupMessage && (
                              <div
                                style={{
                                  backgroundColor: "#e6ffed",
                                  color: "#276749",
                                  padding: "10px 15px",
                                  marginBottom: "20px",
                                  border: "1px solid #c6f6d5",
                                  borderRadius: "6px",
                                  fontWeight: "bold",
                                }}
                              >
                                {setupMessage}
                              </div>
                            )}

                            <div
                              className="d-flex justify-content-start align-items-center"
                              style={{ marginBottom: "15px" }}
                            >
                              <Field
                                type="checkbox"
                                name="agreeToTermsAndCondition"
                                id="agreeToTermsAndCondition"
                                checked={values.agreeToTermsAndCondition}
                                onChange={(e) => {
                                  handleChange(e);
                                  setAgreeToTermsAndConditionByCheck(true);
                                }}
                                style={{
                                  marginRight: "10px",
                                  transform: "scale(1.2)",
                                }}
                              />
                              <label>
                                I agree to the{" "}
                                <Link
                                  to={`${homeUrl}/TermsOfService.html`}
                                  target="_blank"
                                  style={{ textDecoration: "underline" }}
                                >
                                  Terms and Conditions
                                </Link>
                              </label>
                            </div>

                            <div className="d-flex justify-content-between mt-3">
                              <Button
                                onClick={handlePreviousStep}
                                className="btn btn-secondary"
                              >
                                Previous
                              </Button>
                              <Button
                                type="submit"
                                className="btn btn-primary"
                                disabled={
                                  isSubmitting ||
                                  emailExistsError ||
                                  agreeToTermsAndConditionByCheck === false
                                }
                              >
                                {isSubmitting ? "Registering..." : "Register"}
                              </Button>
                            </div>
                          </>
                        )}
                        {errorMessage && (
                          <div
                            className="text-danger"
                            style={{ marginBottom: "20px" }}
                          >
                            {errorMessage}
                          </div>
                        )}
                        {userDeactivtaeErrorMsg && (
                          <div className="text-danger">
                            {userDeactivtaeErrorMsg}
                          </div>
                        )}
                      </Form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>

        {/* OTP Modal */}
        <Modal
          show={showOTPModal}
          onHide={() => setShowOTPModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              OTP Verification
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>
              A verification code has been sent to your
              email. Please enter it below:
            </p>

            <TextField
              type="text"
              name="otp"
              placeholder="Enter Code"
              value={enterOtpValue}
              onChange={(e) =>
                setEnterOtpValue(e.target.value)
              }
            />

            {errorMessage && (
              <div
                className="text-danger"
                style={{ marginBottom: "20px" }}
              >
                {errorMessage}
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() =>
                setShowOTPModal(false)
              }
            >
              Cancel
            </Button>

            <Button
              variant="primary"
              onClick={handleOTPVerification}
            >
              Verify Code
            </Button>
          </Modal.Footer>
        </Modal>

        {showActivationModal && (
          <ActivataionAccount
            userEmail={userEmail}
            onClose={() =>
              setShowActivationModal(false)
            }
          />
        )}

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
        />
      </Card>
    </div>
  </div>
</div>
  );
};

export default HRSignup;
